<nav class="col lh-1">
  <small>
    <a class="focus-visible d-inline-block" href="" (click)="returnToDashboard($event)">
      {{ 'dashboard' | translate }}
    </a>
  </small>
  <span class="mx-2">/</span>
  <small>{{ navigation_title }}</small>
</nav>
